export const PROJECT_TYPES = ['Pipeline', 'Fabrication', 'Others'] as const;
export const STATUS_TYPES = ['Initiated', 'Active', 'On Hold', 'Completed'] as const;
export const PROJECTS_PER_PAGE = 10;

// CRCE design-system status styles: pill bg + text; StatusBadge appends a colored dot via bg-current.
export const STATUS_COLORS = {
  'Initiated': 'text-[#B38600] bg-[rgba(230,161,0,0.08)]',
  'Active': 'text-blueprint-blue bg-[rgba(0,39,63,0.06)]',
  'On Hold': 'text-[#B38600] bg-[rgba(230,161,0,0.08)]',
  'Completed': 'text-galvanizing-green bg-[rgba(31,154,58,0.08)]',
  'default': 'text-heritage-grey bg-[rgba(150,150,150,0.08)]',
  'Not Started': 'text-readable-red bg-[rgba(196,0,31,0.06)]',
} as const;
